/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { PaginatedCadasterListListResponse } from '../types/PaginatedCadasterListList';

import type { UseResource } from '../../hooks/useResource';
import { useResource } from '../../hooks/useResource';

export type CadastersListRequest = {} | null | undefined;
export type CadastersListResponse = PaginatedCadasterListListResponse;

export type CadastersListQuery = {
  /**
   * ```yaml
   * in: query
   * name: name__icontains
   * schema:
   *   type: string
   * ```
   */
  name__icontains?: string;

  /**
   * ```yaml
   * name: page
   * required: false
   * in: query
   * description: A page number within the paginated result set.
   * schema:
   *   type: integer
   * ```
   */
  page?: number;

  /**
   * ```yaml
   * name: page_size
   * required: false
   * in: query
   * description: Number of results to return per page.
   * schema:
   *   type: integer
   * ```
   */
  page_size?: number;
};

/**
 * GET /dmx-server/cadasters/
 *
 * ```yaml
 * operationId: cadasters_list
 * tags:
 *   - cadasters
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/PaginatedCadasterListList'
 *     description: ''
 * ```
 */
export const cadastersListOperation = (rest?: CadastersListQuery | null) =>
  ({
    method: 'GET',
    path: `/dmx-server/cadasters/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'GET';
    path: string & { _templateUrl: '/dmx-server/cadasters/' };
  };

/**
 * GET /dmx-server/cadasters/
 *
 * ```yaml
 * operationId: cadasters_list
 * tags:
 *   - cadasters
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/PaginatedCadasterListList'
 *     description: ''
 * ```
 */
export const cadastersList = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query?: CadastersListQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<PaginatedCadasterListListResponse>> => {
  const operation = cadastersListOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'GET',
    request,
    onUploadProgress,
    cancelToken,
  );
};

/**
 * GET /dmx-server/cadasters/
 */
export const useCadastersListResource = (
  query: CadastersListQuery | null,
  useCached?: boolean,
): UseResource<CadastersListResponse> => {
  return useResource<CadastersListResponse>({
    path: query === null ? null : cadastersListOperation(query).path,
    apiUrl: globalThis.DMX_CONFIG.server,
    useCached,
  });
};
